"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorOverlay = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_theme_provider_1 = require("@gooddata/sdk-ui-theme-provider");
var Button_1 = require("../Button");
var Icon_1 = require("../Icon");
var Typography_1 = require("../Typography");
var Overlay_1 = require("./Overlay");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var ErrorOverlayCore = function (props) {
    var _a, _b;
    var _c = props.showIcon, showIcon = _c === void 0 ? true : _c, _d = props.showButton, showButton = _d === void 0 ? true : _d, icon = props.icon, title = props.title, text = props.text, buttonTitle = props.buttonTitle, onButtonClick = props.onButtonClick, className = props.className, intl = props.intl;
    var theme = sdk_ui_theme_provider_1.useTheme();
    var IconComponent = icon !== null && icon !== void 0 ? icon : (react_1.default.createElement(Icon_1.Icon.Leave, { color: (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _a === void 0 ? void 0 : _a.primary) === null || _b === void 0 ? void 0 : _b.base, className: "gd-error-overlay-icon" }));
    var titleContent = title !== null && title !== void 0 ? title : intl.formatMessage({ id: "error.overlay.title" });
    var textContent = text !== null && text !== void 0 ? text : intl.formatMessage({ id: "error.overlay.text" });
    var buttonValue = buttonTitle !== null && buttonTitle !== void 0 ? buttonTitle : intl.formatMessage({ id: "error.overlay.login" });
    return (react_1.default.createElement(Overlay_1.Overlay, { isModal: true, positionType: "fixed", alignPoints: [{ align: "cc cc" }], closeOnEscape: false, closeOnParentScroll: false, closeOnOutsideClick: false, closeOnMouseDrag: false, zIndex: 10001, containerClassName: "gd-error-overlay-content", className: className },
        react_1.default.createElement("div", { className: "gd-error-overlay s-error-overlay" },
            showIcon ? IconComponent : null,
            react_1.default.createElement(Typography_1.Typography, { tagName: "h2" }, titleContent),
            react_1.default.createElement("div", { className: "gd-error-overlay-text" }, textContent),
            showButton ? (react_1.default.createElement(Button_1.Button, { className: "gd-button gd-button-action gd-error-overlay-button", value: buttonValue, onClick: onButtonClick })) : null)));
};
var ErrorOverlayWithIntl = react_intl_1.injectIntl(ErrorOverlayCore);
/**
 * @internal
 */
var ErrorOverlay = /** @class */ (function (_super) {
    tslib_1.__extends(ErrorOverlay, _super);
    function ErrorOverlay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorOverlay.prototype.render = function () {
        return (react_1.default.createElement(sdk_ui_1.IntlWrapper, { locale: this.props.locale },
            react_1.default.createElement(ErrorOverlayWithIntl, tslib_1.__assign({}, this.props))));
    };
    return ErrorOverlay;
}(react_1.default.PureComponent));
exports.ErrorOverlay = ErrorOverlay;
//# sourceMappingURL=ErrorOverlay.js.map